// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 887) return "static/chunks/887-d91b87774418f03f.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"312":"0be911dcc3be2ad0","384":"f422626e3481eac6","568":"0ae6a746ac8cad0a","751":"a51e2d88e3dad864","983":"131068c8b8b58235"}[chunkId] + ".js";
};